export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.5 12C12.0855 12 13.4242 13.0543 13.8545 14.5H19C19.5523 14.5 20 14.9477 20 15.5C20 16.0128 19.6135 16.4354 19.1162 16.4932L19 16.5H13.8545C13.4242 17.9457 12.0855 19 10.5 19C8.91097 19 7.56976 17.9409 7.14258 16.4902C7.13862 16.4907 7.13484 16.4927 7.13086 16.4932L7.01367 16.5H5C4.44772 16.5 4 16.0523 4 15.5C4 14.9872 4.38645 14.5646 4.88379 14.5068L5 14.5H7.01367C7.05738 14.5 7.10035 14.5034 7.14258 14.5088C7.57005 13.0586 8.9113 12 10.5 12ZM10.5 14C9.67157 14 9 14.6716 9 15.5C9 16.3284 9.67157 17 10.5 17C11.3284 17 12 16.3284 12 15.5C12 14.6716 11.3284 14 10.5 14ZM13.5 4C15.0855 4 16.4242 5.05434 16.8545 6.5H19C19.5523 6.5 20 6.94772 20 7.5C20 8.01284 19.6135 8.4354 19.1162 8.49316L19 8.5H16.8545C16.4242 9.94566 15.0855 11 13.5 11C11.9145 11 10.5758 9.94566 10.1455 8.5H5C4.44772 8.5 4 8.05228 4 7.5C4 6.98716 4.38645 6.5646 4.88379 6.50684L5 6.5H10.1455C10.5758 5.05434 11.9145 4 13.5 4ZM13.5 6C12.6716 6 12 6.67157 12 7.5C12 8.32843 12.6716 9 13.5 9C14.3284 9 15 8.32843 15 7.5C15 6.67157 14.3284 6 13.5 6Z"
      fill="currentColor"
    />
  </svg>
);
